import { Log } from './log.model';
import { LogInterface } from './log.interface';

export class LogFactory {

    static empty(): Log {
        return new Log('', '', 0, '', '', '', '', '', '');
    }

    static fromObject(raw: LogInterface | any): Log {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Log(
            raw.id,
            raw.category,
            raw.order,
            raw.email,
            raw.userId,
            raw.description,
            raw.debug,
            raw.platform,
            raw.version,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/logs/shared/log.factory.ts